import { CardActionArea, cardActionAreaClasses, styled } from "@mui/material"

export const SimpleWidgetCardActionArea = styled(CardActionArea)({
    height: "100%",
    width: "100%",
    ":hover": {
        [`.${cardActionAreaClasses.focusHighlight}`]: {
            opacity: 0,
        },
    },
})
